var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.8675 92.7775L13.8675 59.775L13.73 54.2775L103.732 12.2825L107.98 15.3575L98.98 90.3575L94.87 92.7775H94.8675ZM22.4925 56.81L93.49 85.7375L101.377 20L22.4925 56.81Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2575 103.975L45 102V69H51V94.015L66.7425 76.025L71.2575 79.975L50.2575 103.975Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.704 13.0668L54.7058 70.0668L59.2953 73.9316L107.294 16.9315L102.704 13.0668Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSend);
export default __webpack_public_path__ + "static/media/Message_Send.cf3f6971.svg";
export { ForwardRef as ReactComponent };